import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import {
   PhoneNumberDetailDeleteEvent,
   PhoneNumberDetailReleaseEvent,
   PhoneNumberDetailSaveEvent,
} from '../models/phone-number-detail-form-submit-event';
import {
   GetPhoneNumberDetail_phoneNumber,
   GetPhoneNumberDetail_phoneNumber_account,
} from '../queries/generated/GetPhoneNumberDetail';
import { SavePhoneNumber } from '../queries/generated/SavePhoneNumber';

export const phoneNumberDetailLoad = createAction('[Phone Number Detail] Load');

export const phoneNumberDetailCancel = createAction('[Phone Number Detail] Cancel');

export const phoneNumberDetailAccessDenied = createAction('[Phone Number Detail] Access Denied');

export const loadPhoneNumberDetailSuccess = createAction(
   '[API] Load Phone Number Success',
   props<{ data: GetPhoneNumberDetail_phoneNumber }>()
);

export const loadSystemPhoneNumberDetailSuccess = createAction(
   '[API] Load System Phone Number Success',
   props<{ data: GetPhoneNumberDetail_phoneNumber }>()
);

export const loadPhoneNumberDetailFailure = createAction('[API] Load Phone Number Failure', props<SingleGraphError>());

export const savePhoneNumberDetail = createAction('[Phone Number Detail] Save', props<PhoneNumberDetailSaveEvent>());

export const releasePhoneNumberDetail = createAction(
   '[Phone Number Detail] Release',
   props<PhoneNumberDetailReleaseEvent>()
);

export const releasePhoneNumberDetailSuccess = createAction(
   '[Phone Number Detail] Release Success',
   props<{ data: any }>()
);

export const releasePhoneNumberDetailFailure = createAction(
   '[Phone Number Detail] Release Failure',
   props<SingleGraphError>()
);

export const savePhoneNumberDetailSuccess = createAction(
   '[Phone Number Detail] Save Success',
   props<{ data: SavePhoneNumber }>()
);

export const savePhoneNumberDetailFailure = createAction(
   '[Phone Number Detail] Save Failure',
   props<SingleGraphError>()
);

export const deletePhoneNumberDetailFromNDT = createAction(
   '[Phone Number Detail] Delete',
   props<PhoneNumberDetailDeleteEvent>()
);

export const deletePhoneNumberDetailFromNDTSuccess = createAction(
   '[Phone Number Detail] Delete Success',
   props<{ data: any }>()
);

export const deletePhoneNumberDetailFromNDTFailure = createAction(
   '[Phone Number Detail] Delete Failure',
   props<SingleGraphError>()
);

export const verifyRoute = createAction(
   '[Phone Number Detail] Verify Route',
   props<{
      accountId: GetPhoneNumberDetail_phoneNumber_account['accountId'];
      phoneNumber: GetPhoneNumberDetail_phoneNumber['phoneNumberId'];
   }>()
);

export const navigate = createAction('[Phone Number Detail] Navigate', props<{ id: number | string }>());
